<template>
  <div class="container-fluid p-0">
    <div v-if="isLoading">
      <Preloader/>
    </div>
    <div v-else>
      <h4 class="w-100 text-center" v-if="deviceReports.length === 0">در حال حاضر این دستگاه هیچ برنامه بازدید یا سرویسی ندارد</h4>
      <table class="table table-striped" v-else>
        <thead>
        <tr>
          <th scope="col" class="text-center">برنامه</th>
          <th scope="col" class="text-center">نوع چک لیست</th>
          <th scope="col" class="text-center">وضعیت</th>
          <th scope="col" class="text-center">مقدار</th>
          <th scope="col" class="text-center">نیاز به بازدید مجدد</th>
          <th scope="col" class="text-center">شرح</th>
          <th scope="col" class="text-center">عملیات</th>

        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in deviceReports">

          <td class="text-center clickable" @click="showReport(item)">{{item.devicePMPlanning.pmCheckList.name}}</td>
          <td class="text-center clickable" @click="showReport(item)">{{item.devicePMPlanning.pmCheckList.enPMListTypeTitle}}</td>
          <td class="text-center clickable"><input type="checkbox" class="form-control" v-model="item.isOk"></td>
          <td class="text-center clickable d-inline-flex" v-if="item.devicePMPlanning.pmCheckList.enPMListType === 3">
            <input type="text" class="form-control" v-model="item.value">
            <span class="input-group-text" >{{item.unit}}</span>
          </td>
          <td v-else class="text-center"> - - - - </td>
          <td class="text-center">
            <input type="checkbox" class="form-control" v-model="item.reCheck">
          </td>
          <td class="text-center">
            <input type="text" class="form-control" v-model="item.report">
          </td>
          <td class="text-center">
            <i class="clickable font-large fa fa-save  px-3" title="ثبت گزارش" @click="saveReportLine(item)"></i>
            <i class="clickable font-large fa fa-recycle px-3" title="سند اقلام تعمیری" @click="createServiceVoucher(item)"></i>
            <i class="clickable font-large fa fa-file-word-o px-3" title="سند اقلام مصرفی" @click="createServiceVoucher(item)"></i>
            <i class="clickable font-large fa fa-unlink px-3" title="سند اقلام ضایعاتی" @click="createDamageVoucher(item)"></i>
          </td>


        </tr>
        </tbody>
      </table>

      <!--<div class="col-12" v-if="showPagination">-->
      <!--<b-pagination size="md" v-model="pageIndex" :total-rows="rows" :per-page="pageSize" align="center"-->
      <!--@input="nextPage(pageIndex)"/>-->
      <!--</div>-->

      <!--  <div class="col-12">
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            @input="onWorksPaginationChange"
            :per-page="pagination.pageSize"
          ></b-pagination>
        </div>-->
    </div>
    <!-------------------------------------------------------------------------------->
    <!------------ ATTACH MODAL----------------------------------------------------------------------------->
    <b-modal
      id="reportModal"
      ref="reportModal"
      size="lg"
      title="گزارش بازدید"
      ok-title="ذخیره"
      cancel-title="بستن"
      @ok="saveReport"
    >

      <div class="row mb-2">
        <h4 class="col-12 w-100 text-center">{{p_name}} {{p_device}}</h4>
        <!--چک لیست  ---------------------->
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>وضعیت(مطلوب/نامطلوب)</span>
              </div>
            </div>
            <input type="checkbox" class="form-control" v-model="reportModel.isOk">

          </div>
        </div>
        <!--پایشی  ---------------------->
        <div class="col-4  mb-2" v-if="p_enPMListType === 3">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>مقدار قرائت شده</span>
              </div>
            </div>
            <input type="text" class="form-control" v-model="reportModel.value">
          </div>
        </div>
        <div class="col-4  mb-2" v-if="p_enPMListType=== 3">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>واحد اندازه گیری</span>
              </div>
            </div>
            <input type="text" readonly class="form-control" v-model="reportModel.unit">
          </div>
        </div>

        <div class="col-12  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>شرح گزارش </span>
              </div>
            </div>
            <input type="text" class="form-control" v-model="reportModel.report">

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>نیاز به بازدید مجدد</span>
              </div>
            </div>
            <input type="checkbox" class="form-control" v-model="reportModel.reCheck">

          </div>
        </div>
      </div>

    </b-modal>


    <!------------ SHENASNAMEH  MODALS -------------------------------------------------------------------->


  </div>
</template>

<script>

  import VsSelect from "../../_framework/VsSelect";
  import BaseService from "../../_framework/api/BaseService.js";
  import Moment from "moment-jalali";
  import Vue from "vue";
  import Products from "../Products.vue";
  import * as $ from 'jquery';
  import checkAccess from "../../checkAccess";
  import CreateWork from "../CreateWork";
  import Utils from "../../_framework/utils/Utils";
  import VueHtmlToPaper from 'vue-html-to-paper';
  import DatePicker from "../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
  import Constants from "../../Constants";
  import BdInput from "../../components/BDInput";

  export default {
    name: "device-check-services",
    props: {},
    components: {
      BdInput,
      CreateWork,
      VsSelect,
      Products,
      datePicker: DatePicker,
    },
    data: function () {
      return {

        isLoading: false,
        companyId: 0,
        deviceReports: [],
        enPMListTypes: [],
        reportModel: {
          devicePMPlanningId: 0,
          id: 0,
          reCheck: false,
          report: "",
          reportDate: "0001-01-01T00:00:00",
          serviceVoucher: null,
          status: false,
          unit: "",
          userId: 1,
          value: "",
        },
        p_enPMListType: 0,
        p_name: "",
        p_unit: "",
        p_device: "",

      }
    },
    mounted() {
      const printoptions = {
        name: '_blank',
        specs: [
          'fullscreen=yes',
          'titlebar=yes',
          'scrollbars=yes',

        ],
        styles: [
          './css/bootstrap4.min.css',
          './css/kidlat.css',
          './css/print-style.css',

        ],
        timeout: 10,
        autoClose: false,
        windowTitle: "شرکت آبان توسعه / پرینت رسید انبار"

      };
      Vue.use(VueHtmlToPaper, printoptions);
      if (this.$route.params.companyId === undefined) {
        this.$router.push({path: "/check-services"});
      }
      this.getType();

      // this.getType();
    },
    methods: {
      getType() {
        new BaseService('PManagment', '/GetEnPMListType').getList().then((response) => {
          this.enPMListTypes = response.data;
          if (this.$route.params.companyId !== undefined && this.$route.params.companyId !== null && this.$route.params.companyId !== 0) {
            this.companyId = this.$route.params.companyId;
            this.getDeviceReports();
          }
          // console.log(response.data)
        }).catch((error) => {
          console.log(error)
        });
      },
      getDeviceReports() {
        new BaseService('PManagment', `/GetDevicePMReport/${this.companyId}/${false}`).getList().then((response) => {
          this.deviceReports = response.data;
          if(this.deviceReports.length ===0){
            this.$router.push({path: "/check-services"});
          }else {
            for (let i of this.deviceReports) {
              for (let e of this.enPMListTypes) {
                if (e.value === i.devicePMPlanning.pmCheckList.enPMListType) {
                  i.devicePMPlanning.pmCheckList.enPMListTypeTitle = e.title;
                }
              }
              i.unit = i.devicePMPlanning.pmCheckList.unit;
            }
          }
        }).catch((error) => {
          console.log(error)
        });
      },
      saveReport() {
        this.reportModel.status = true;
        if (this.reportModel.reCheck && (this.reportModel.report === null || this.reportModel.report === "")) {
          this.$noty.error("لطفا علت بازدید مجدد را شرح دهید");
        } else {
          new BaseService('PManagment/UpdateDevicePMReport').update(this.reportModel).then((response) => {
            this.$noty.success("با موفقیت ثبت شد");
            this.getDeviceReports();
          }).catch((error) => {
            console.log(error)
          });
        }
      },
      saveReportLine(item) {
        item.status = true;
        if (item.reCheck && (item.report === null || item.report === "")) {
          this.$noty.error("لطفا علت بازدید مجدد را شرح دهید");
        } else if (item.devicePMPlanning.pmCheckList.enPMListType === 3 && (item.value === null || item.value === "")) {
          this.$noty.error("لطفا مقدار قرائت شده راوارد کنید");
        } else {
          new BaseService('PManagment/UpdateDevicePMReport').update(item).then((response) => {
            this.$noty.success("با موفقیت ثبت شد");
            this.getDeviceReports();
          }).catch((error) => {
            console.log(error)
          });
        }
      },
      showReport(item) {
        this.p_enPMListType = item.devicePMPlanning.pmCheckList.enPMListType;
        this.p_name = item.devicePMPlanning.pmCheckList.name;
        this.p_unit = item.devicePMPlanning.pmCheckList.unit;

        this.p_device = item.devicePMPlanning.company.companyName;
        this.reportModel = item;
        this.reportModel.unit = this.p_unit;
        this.$refs['reportModal'].show();
      },
      createDamageVoucher(item){
          // this.$router.push({
          //   path: "/pm-voucher",
          //   query: {_mode, _data}
          // });
      },
      createServiceVoucher(item){},

    },

    computed: {
      myStylestx1() {
        return {
          height: `${this.tx1Height}px`,
          position: 'relative'
        }
      }
    }
  };

</script>

<style scoped>
  .table th, .table td {
    padding: 0.5rem !important;
  }
</style>
